<script setup lang="ts">
  import type { IFooterLink } from '@/components/main-footer/types'

  const { isDesktop } = useBTBreakpoints()

  defineProps<{
    footerLinks: IFooterLink[]
  }>()

  const value = ref()
</script>

<template>
  <template v-if="!isDesktop">
    <MainFooterAccordion
      v-model="value"
      type="multiple"
    >
      <template
        v-for="section in footerLinks"
        :key="section.label"
      >
        <MainFooterAccordionItem :value="`item-${section.label}`">
          <template #title> {{ section.label }}</template>
          <template #content>
            <ul class="mb-6 flex list-none flex-col gap-4">
              <li
                v-for="child in section.children"
                :key="child.key"
              >
                <NuxtLink
                  :to="child.href"
                  :target="child.linkTarget"
                  :rel="child.rel"
                  class="no-underline"
                  external
                >
                  <div class="relative">
                    {{ child.label }}
                    <span
                      v-if="child.rel !== null"
                      class="absolute inline-block text-bt-blue-dark"
                    >
                      <LazyIcon
                        name="common/new-tab"
                        size="xxs"
                      />
                    </span>
                  </div>
                </NuxtLink>
              </li>
            </ul>
          </template>
        </MainFooterAccordionItem>
      </template>
    </MainFooterAccordion>
  </template>
  <template v-else>
    <div
      v-for="menu in footerLinks"
      :key="menu.key"
      class="w-52 flex-col gap-4 pt-10 md:flex"
    >
      <NuxtLink
        :to="menu.href"
        class="font-medium leading-6 text-bt-blue-dark no-underline"
        external
      >
        {{ menu.label }}
      </NuxtLink>
      <ul class="mb-6 flex list-none flex-col gap-4 p-0">
        <li
          v-for="child in menu.children"
          :key="child.key"
        >
          <NuxtLink
            :to="child.href"
            :target="child.linkTarget"
            :rel="child.rel"
            class="no-underline"
            external
          >
            <div class="relative">
              {{ child.label }}
              <span
                v-if="child.rel !== null"
                class="absolute inline-block text-bt-blue-dark"
              >
                <Icon
                  name="common/new-tab"
                  size="xxs"
                />
              </span>
            </div>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </template>
</template>
